import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {MODEL_INPUT_TYPE} from 'model-hub/scientific-models/data-first/CustomEntityInputTypeDefinitions';
import {MODEL_CATEGORY, ScientificModelNode} from 'model-hub/scientific-models/ScientificModelMetadata';
import {GetPipelineConfigSpecType, PipelineConfigJsonSpec} from 'pipelines/StepShapeUtils';

const REQUIRED_TEXT_INPUT_DATASET_COLUMN: GetPipelineConfigSpecType<'columnReference'> = {
  kind: 'columnReference',
  required: true,
  inputDataName: 'inputDataset',
  allowMissingColumn: false,
  validationOptions: {
    allowedLeafTypes: [LeafType.TEXT],
    listType: ColumnTypeValidationFlag.NOT_ALLOWED,
  },
};

interface ModelInputField {
  key: string;
  displayName: string;
  spec: PipelineConfigJsonSpec;
}

// Keep in sync with scientific_model_job_config_builder.py, which reads these keys for the same
// model capabilities.
export function getModelInputFields(model: ScientificModelNode): ReadonlyArray<ModelInputField> | null {
  if (model.category === MODEL_CATEGORY.PROPERTY_PREDICTION) {
    if (model.inputTypes.includes(MODEL_INPUT_TYPE.ANTIBODY)) {
      return [
        {
          key: 'heavyChainColumn',
          displayName: 'Heavy-chain sequence column',
          spec: REQUIRED_TEXT_INPUT_DATASET_COLUMN,
        },
        {
          key: 'lightChainColumn',
          displayName: 'Light-chain sequence column',
          spec: REQUIRED_TEXT_INPUT_DATASET_COLUMN,
        },
      ];
    }
    if (model.inputTypes.includes(MODEL_INPUT_TYPE.MOLECULE)) {
      return [{key: 'smilesColumn', displayName: 'SMILES column', spec: REQUIRED_TEXT_INPUT_DATASET_COLUMN}];
    }
    return null;
  }
  return null;
}
